import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import BoostUpDetail from '../../components/lms/membership-store/boostup/boostupdetail';
import LmsLayout from '../../components/lmslayout';
import Dashboard from './dashboard/Dashboarad';
import CourseMgmt from './classmgmt/coursemgmt/CourseMgmt';
import TakeClass from './take-class/TakeClass';
import ReferenceRoom from './classmgmt/referenceroom/referenceroom';
import NoticeDetail from './noticemgmt/noticedetail';
import NoticeEditor from './noticemgmt/noticeeditor';
import Signupmgmt from './studentmgmt/signupmgmt';
import LmsMigrationPage from './migration/LmsMigrationPage';
import StudentDetail from './studentmgmt/StudentDetail';
import ClassSetting from './classsetting/ClassSetting';
import ChannelService from '../../api/ChannelService';
import LmsEvent from './LmsEvent';
import CreateAssignment from './assignment-mgmt/CreateAssignment';
import AssignmentStatus from './assignment-mgmt/AssignmentStatus';
import CreateRecitation from './recitation-mgmt/CreateRecitation';
import RecitationStatus from './recitation-mgmt/RecitationStatus';
import VoucherManagement from './voucher-mgmt/VoucherManagement';
import MembershipStore from './membership-store/MembershipStore';

const RouteLms = () => {
  useEffect(() => {
    ChannelService.hideChannelButton();
    return () => {
      ChannelService.showChannelButton();
    };
  }, []);

  return (
    <Routes>
      {/* base "/lms/:classId" */}

      {/* 부스트업 상세페이지 */}
      <Route path="/boostup/detail/:boostupId" element={<BoostUpDetail />} />

      {/* LMS */}
      <Route element={<LmsLayout />}>
        {/* 대쉬보드 */}
        <Route index path="/dashboard" element={<Dashboard />} />

        {/* 코스관리 */}
        <Route path="/course-management" element={<CourseMgmt />} />

        {/* 수업하기 */}
        <Route path="/take-class" element={<TakeClass />} />

        {/* 과제 관리 > 과제 내주기 */}
        <Route path="/assignment/create" element={<CreateAssignment />} />

        {/* 과제 관리 > 과제 현황 */}
        <Route path="/assignment/status" element={<AssignmentStatus />} />

        {/* AI인증제 관리 > AI인증제 내주기 */}
        <Route path="/recitation/create" element={<CreateRecitation />} />

        {/* AI인증제 관리 > AI인증제 현황 */}
        <Route path="/recitation/status" element={<RecitationStatus />} />

        {/* 이용권 관리 */}
        <Route path="/voucher" element={<VoucherManagement />} />

        {/* 멤버십 스토어 */}
        <Route path="/membership-store" element={<MembershipStore />} />

        {/* 자료실 */}
        <Route path="/reference-room" element={<ReferenceRoom />} />

        {/* 공지 상세 */}
        <Route path="/notice/detail/:detailId" element={<NoticeDetail />} />

        {/* 게시물 작성 */}
        <Route path="/notice/editor" element={<NoticeEditor />} />

        {/* 학생 관리 */}
        <Route path="/signup-management" element={<Signupmgmt />} />

        {/* 학생 상세 */}
        <Route
          path="/signup-management/:studentId"
          element={<StudentDetail />}
        />

        {/* 학생 가져오기 [ 구젭스 ] */}
        <Route path="/migration" element={<LmsMigrationPage />} />

        {/* 클래스 설정 */}
        <Route path="/class-setting" element={<ClassSetting />} />

        {/* 이벤트 노션 */}
        <Route path="/event" element={<LmsEvent />} />

        {/* 비정상 접근시 대쉬보드로 */}
        {/* <Route path="/*" element={<InvalidRouteRedirect />} /> */}
      </Route>
    </Routes>
  );
};

const InvalidRouteRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 대쉬보드로 replace 리다이렉트
    navigate('./dashboard', { replace: true });
  }, [navigate]);
  return <></>;
};

export default RouteLms;
